import React, { useEffect } from "react";
import Radio from "@mui/material/Radio";
import { useState } from "react";
import { Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import "./ImageConfiguratorList.scss";
import Gallery from "../../../Images/gallery.svg";
import Info from "../../../Images/yellow_info_icon.svg";
import Button from "../../common/Button";
import { styled } from "@mui/material/styles";
import { Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  imageSelectedData,
  cloudType,
} from "../../../redux/features/ImageConfigReducer";
import MultiLine_Spinner from "../../multiline_spinner/Multiline_spinner";
import Cookies from "universal-cookie";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import api_call from "../../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import { API } from "../../../globals/constants";
import { useStateManager } from "react-select";
import { filter } from "lodash";

function ImageConfiguratorList(props) {
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState("training");
  const [isLoading, setIsloading] = useState(false);
  const [handleImage, setHandleImage] = useState("");
  const [amiData, setAmiData] = useState([]);

  const cookies = new Cookies();
  const { email_id, token, role_code, name, studio_id, id } =
    cookies.get("loginData");
  const stateAction = useSelector((state) => {
    return state?.ImageDetails?.stateAction;
  });
  const handleImageselection = (val) => {
    setHandleImage(val);
    props.handleStateChange(true);
  };
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setHandleImage("");
    dispatch(cloudType(""));
  };

  const handleDelete = (val) => {
    // let bodyParam = {
    //   is_accept: false,
    //   arn: val.amiarn,
    //   ami_name: ami_name,
    //   created_by: id,
    //   isFail: true,
    // };
  };
  const ImageSelectedData = useSelector((state) => {
    return state?.ImageDetails?.imageSelectedData;
  });
  const selectedSessionOption = useSelector((state) => {
    console.log("check the state value ", state?.ImageDetails);
    return state?.ImageDetails?.cloudType;
  });

  const add3Dots = (string, limit) => {
    let dots = "...";
    if (string.length > limit) {
      string = string.substring(0, limit) + dots;
    }
    return string;
  };
  const toolTipText = (text, project_description) => {
    const tools = project_description
      ? project_description?.map((item, index) => {
          return `${index + 1}.${item?.tool_name} \n`;
        })
      : [];
    const project = text
      ? text?.map((item, index) => {
          return `${index + 1}.${item?.project_name} \n`;
        })
      : [];
    const tooltip = project_description
      ? `Tools: \n ${tools.toString()} \n Project: \n ${project.toString()}`
      : `Tools: \n ${text}`;
    return (
      <p style={{ whiteSpace: "pre-line" }} className="line-break">
        {tooltip}
      </p>
    );
  };
  const handleContinue = () => {
    if (handleImage === "" || handleImage === undefined) {
      toast.error(`Please select any one image from the list`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else {
      dispatch(imageSelectedData(handleImage));
      dispatch(cloudType({ sessionType: selectedValue }));
      return props.handleNext();
    }
  };
  const ImageList = async () => {
    setIsloading(true);
    let params =
      selectedValue === "training"
        ? {
            createdBy: role_code === "STUDIO_ADMIN" ? studio_id : id,
            cloud_type: "AWS",
          }
        : {
            createdBy: role_code === "STUDIO_ADMIN" ? studio_id : id,
            cloud_type: "GCP",
            region: "asia-south1",
          };
    const response = await api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.IMAGECONFIGURATOR_LIST
      }`,
      selectedSessionOption?.sessionType
        ? selectedSessionOption?.sessionType === "training"
          ? {
              createdBy: role_code === "STUDIO_ADMIN" ? studio_id : id,
              cloud_type: "AWS",
            }
          : {
              createdBy: role_code === "STUDIO_ADMIN" ? studio_id : id,
              cloud_type: "GCP",
              region: "asia-south1",
            }
        : params,
      {},
      {}
    );

    if (response.status === 200) {
      setIsloading(false);
      let data = response?.data?.data?.new_ami;
      setAmiData([...data]);
    } else {
      setIsloading(false);
    }
  };
  const getImageData = () => {
    if (ImageSelectedData) {
      let filterData = amiData.filter(
        (item) =>
          item?.ami?.ami_id === ImageSelectedData?.ami?.ami_id ||
          item?.ami?.ami_id === ImageSelectedData?.base_ami
      );
      console.log("filter data check --", ImageSelectedData);
      setHandleImage(filterData[0]);
    }
  };
  useEffect(() => {
    if (ImageSelectedData) {
      getImageData();
    }
  }, [amiData]);
  useEffect(() => {
    if (ImageSelectedData) {
      getImageData();
    }
  }, [ImageSelectedData]);

  useEffect(() => {}, [handleImage]);

  useEffect(() => {}, [amiData]);
  useEffect(() => {
    console.log("data chk ---", selectedSessionOption);
    if (selectedSessionOption) {
      setSelectedValue(selectedSessionOption?.sessionType);
    }
  }, [selectedSessionOption]);
  useEffect(() => {
    ImageList();
  }, [selectedValue]);
  useEffect(() => {
    ImageList();
  }, []);
  useEffect(() => {
    console.log("window", window.location.pathname);

    if (props.backState === true) {
    } else {
      if (window.location.pathname === "/admin/imageconfigurator") {
        dispatch(imageSelectedData(""));
        dispatch(cloudType(""));
        setHandleImage("");
      }
    }
  }, [window.location.pathname]);

  return (
    <>
      <Grid conatiner spacing={2} className="imageList">
        {console.log("chk the data ----", selectedValue)}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box>
            <div className="flexClass Type_ami_heading">
              <Typography className="ami_name">
                This AMI will be used for:
              </Typography>
              <div className="flexClass sessionSelect ">
                <input
                  type="radio"
                  value="training"
                  onChange={(e) => handleChange(e)}
                  checked={selectedValue === "training" ? true : false}
                  disabled={stateAction?.action === "edit"}
                />

                <Tooltip
                  title={
                    "Selecting 'Training' will allow you to schedule VMs that are available only during class hours and not the entire day. They will be hosted on AWS and will be accessible through a browser."
                  }
                  placement="top-start"
                  arrow
                >
                  <label className="ami_name">Training</label>
                </Tooltip>

                <input
                  type="radio"
                  value="longtermsession"
                  onChange={(e) => handleChange(e)}
                  checked={selectedValue === "longtermsession" ? true : false}
                  disabled={stateAction?.action === "edit"}
                />
                <Tooltip
                  title={
                    "Selecting 'Longterm Session' will create images that are on all the time (24X7). These are typically used for 'Fellowship' programs. They will be hosted on Google Cloud and will be accessible through Teradici. "
                  }
                  placement="top-start"
                  arrow
                >
                  <label className="ami_name">Longterm Session</label>
                </Tooltip>
              </div>
            </div>
            <Grid container item>
              <Grid xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className="Img_listing">
                  <div className="FlexDisplay">
                    <div>
                      <Typography
                        variant="h6"
                        sx={{ color: "#fff" }}
                        className="imageHeader"
                      >
                        {" "}
                        Private Image
                      </Typography>
                    </div>

                    <div className="">
                      <Tooltip
                        title="These AMI will be privately owned and visible to the only one who created the images."
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} />
                      </Tooltip>
                    </div>
                  </div>
                  <div className="ImageBgColor">
                    {amiData?.map((val, ind) => {
                      if (val.ami.is_private === true) {
                        return (
                          <div
                            className={
                              handleImage
                                ? val?.ami?.id === handleImage?.ami?.id ||
                                  handleImage?.base_ami === val?.ami?.ami_id
                                  ? "image_selected "
                                  : "ImageInfo"
                                : "ImageInfo"
                            }
                            onClick={() =>
                              stateAction?.action === "edit"
                                ? ""
                                : handleImageselection(val)
                            }
                          >
                            <Grid xs={12} sm={12} md={10} lg={10} xl={10}>
                              <div className="FlexDisplay">
                                <div className="galleryImg">
                                  <img src={Gallery} className="gallery_img" />
                                </div>

                                {window.innerWidth > 768 ? (
                                  <Tooltip
                                    title={val.ami.name}
                                    placement="top-start"
                                    arrow
                                  >
                                    <div className="verticalAlign">
                                      {add3Dots(val.ami.name, 15)}
                                    </div>
                                  </Tooltip>
                                ) : (
                                  <div className="verticalAlign">
                                    {val.ami.name}
                                  </div>
                                )}
                              </div>
                            </Grid>{" "}
                            {window.innerWidth > 768 ? (
                              <Grid xs={1} sm={1} md={1} lg={1} xl={1}>
                                <div className="verticalAlign">
                                  <Tooltip
                                    title={toolTipText(val.project, val.tools)}
                                    placement="top-start"
                                    arrow
                                  >
                                    <img src={Info} />
                                  </Tooltip>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {/* <Grid xs={1} sm={1} md={1} lg={1} xl={1}>
                              <div className="verticalAlign">
                                <Tooltip
                                  title="Delete"
                                  placement="top-start"
                                  arrow
                                >
                                  <img src={Delete} />
                                </Tooltip>
                              </div>
                            </Grid> */}
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </Grid>
              <Grid xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className="Img_listing">
                  <div className="FlexDisplay">
                    <div>
                      <Typography
                        variant="h6"
                        sx={{ color: "#fff" }}
                        className="imageHeader"
                      >
                        {" "}
                        Public Image
                      </Typography>
                    </div>

                    <div className="">
                      <Tooltip
                        title="Publicly available images are visible to all other users."
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} />
                      </Tooltip>
                    </div>
                  </div>

                  <div className="ImageBgColor">
                    {amiData?.map((val, ind) => {
                      if (val.ami.is_private === false) {
                        return (
                          <div
                            className={
                              val?.ami?.id === handleImage?.ami?.id ||
                              handleImage?.base_ami === val?.ami?.ami_id
                                ? "image_selected "
                                : "ImageInfo"
                            }
                            onClick={() =>
                              stateAction?.action === "edit"
                                ? ""
                                : handleImageselection(val)
                            }
                          >
                            <Grid xs={12} sm={12} md={10} lg={10} xl={10}>
                              <div className="FlexDisplay">
                                <div className="galleryImg">
                                  <img src={Gallery} className="gallery_img" />
                                </div>
                                {window.innerWidth > 768 ? (
                                  <Tooltip
                                    title={val.ami.name}
                                    placement="top-start"
                                    arrow
                                  >
                                    <div className="verticalAlign">
                                      {add3Dots(val.ami.name, 15)}
                                    </div>
                                  </Tooltip>
                                ) : (
                                  <div className="verticalAlign">
                                    {val.ami.name}
                                  </div>
                                )}
                              </div>
                            </Grid>
                            {window.innerWidth > 768 ? (
                              <Grid xs={1} sm={1} md={1} lg={1} xl={1}>
                                <div className="verticalAlign">
                                  <Tooltip
                                    title={toolTipText(val.project, val.tools)}
                                    placement="top-start"
                                    arrow
                                  >
                                    <img src={Info} />
                                  </Tooltip>
                                </div>
                              </Grid>
                            ) : (
                              ""
                            )}

                            {/* <Grid xs={1} sm={1} md={1} lg={1} xl={1}>
                              <div className="verticalAlign">
                                <Tooltip
                                  title="Delete"
                                  placement="top-start"
                                  arrow
                                >
                                  <img
                                    src={Delete}
                                    onClick={() => handleDelete(val)}
                                  />
                                </Tooltip>
                              </div>
                            </Grid> */}
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid item conatiner>
              <Grid xs={6} sm={6} md={3} lg={3} xl={3}>
                <div className="ContinueBtn">
                  <Button
                    value="Continue"
                    onClick={() => handleContinue()}
                    className=""
                    role="primary"
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      {isLoading && <MultiLine_Spinner />}
    </>
  );
}

export default ImageConfiguratorList;
